import React from "react";
import { ProviderDocuments } from "./ProviderDocuments";
import { ResidentHistory } from "./ResidentHistory";
// 2026-10-27 (facility records Phase 0c): the visit note the facility receives, written by the provider who works them.
import { VisitNote } from "./VisitNote";

/**
 * The resident's record for the providers who work them (2026-10-22): audiology referrals and History v1, mounted by
 * the resident workbench beside the private notes with one line, so the workbench itself barely changes.
 */
export interface ProviderResidentRecordProps {
  facilityId: string;
  patientId: string;
  canUpload: boolean;
}

export function ProviderResidentRecord({ facilityId, patientId, canUpload }: ProviderResidentRecordProps) {
  return (
    <div data-testid="provider-resident-record">
      <VisitNote facilityId={facilityId} patientId={patientId} canWrite={canUpload} />
      <ProviderDocuments facilityId={facilityId} patientId={patientId} canUpload={canUpload} />
      <ResidentHistory facilityId={facilityId} patientId={patientId} />
    </div>
  );
}
export default ProviderResidentRecord;
